var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoaderOrangeCommon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 40,
    height: 40,
    style: {
      shapeRendering: "auto",
      display: "block"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#ff600c",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1",
    values: "10;0",
    keyTimes: "0;1",
    calcMode: "spline",
    dur: "0.7575757575757576s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "#ff600c;#ffefe7;#ffba95;#ff945b;#ff600c",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "discrete",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ff600c",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ff945b",
    r: 10,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.7575757575757576s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.7575757575757576s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffba95",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-1.5151515151515151s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-1.5151515151515151s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffefe7",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-2.2727272727272725s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-2.2727272727272725s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "3.0303030303030303s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderOrangeCommon);
export default __webpack_public_path__ + "static/media/loader_orange_common.e53a35c52c7664fb21006750c187a482.svg";
export { ForwardRef as ReactComponent };